import { Component, OnInit, ElementRef } from "@angular/core";
import { ProductService } from "src/app/core/services/product.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-categories-modern",
  templateUrl: "./categories-modern.component.html",
  styleUrls: ["./categories-modern.component.css"],
})
export class CategoriesModernComponent implements OnInit {
  categories: [];
  public urlHost = "";
  public loading: boolean = true;
  constructor(
    private productService: ProductService,
    private elementRef: ElementRef
  ) {
    this.urlHost = environment.urlHostImage;
  }

  ngOnInit() {
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#262626';
    this.getCategories();
  }

  getCategories() {
    this.loading = true;
    this.productService.getCategories().subscribe(
      (data) => {
        this.categories = data;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        console.log(error);
      }
    );
  }
}
